<template>
    <div style="background:#3A3C9C;">

  <div style="width: 100%;border-radius:0.5rem" :style="xuqiu">
    <div style="padding-top: 2.5rem">
      <div :class="show ? 'xz-BgColor-All' : ''">
      <input
        placeholder="请输入姓名"
        style="margin-top: 1rem; width: 87%; margin-left: 5%;border:1px solid #6791AD;padding-left:3%"
        v-model="info.name"
      />
      <input
        placeholder="请输入手机号"
        style="margin-top: 1rem; width: 87%; margin-left: 5%;border:1px solid #6791AD;padding-left:3%"
        v-model="info.telephone"
      />
      <textarea
        placeholder="请输入需求"
        style="margin-top: 1rem; width: 85%; margin-left: 5%;border:1px solid #6791AD;padding-left:3%"
        v-model="info.demand"
      />
      <van-button
        type="danger"
        style="width: 90%; margin-left: 5%; margin-bottom: 30px;margin-top:0.6rem
border-radius: 0.3rem;"
        @click="sub"
        color="#BF4333"
        >点击提交</van-button
      >
      </div>
    
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props:{
    show:{
      type:Boolean,

    }
  },
  data() {
    return {
      xuqiu: {
        // contain
        background:
          "url(" + require("@/assets/imgs/enterprise/16.png") + ") no-repeat",
        backgroundSize: "contain",
      },
      info: {
        name: "",
        telephone: "",
        demand: "",
      },
    };
  },
  methods: {
    sub() {
      if (this.info.name == "") {
        this.$toast("请填写姓名");
        return false;
      }
      if (this.info.telephone == "") {
        this.$toast("请填写联系手机号");
        return false;
      }
      if (this.info.demand == "") {
        this.$toast("请填写需求简述");
        return false;
      }
      let data = this.info
      this.Api({
        url:'api/EnterpriseTrain/addTrainInfo',
        method: "POST",
        data
      }).then(res => {
        if(res.retuCode == 5000){
          this.$toast("提交成功")
          this.info.name = ""
          this.info.telephone = ""
          this.info.demand = ""
        }else {
          this.$toast("提交失败")
        }
      })
    },
  },
};
</script>

<style scoped>
</style>